// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatioWrapper_root__2m59p","aspectPadding":"AspectRatioWrapper_aspectPadding__ODzN3","aspectBox":"AspectRatioWrapper_aspectBox__pzXZ8"};